import { Button } from '../ui/button';
import { Check, Wrench, ChevronRight } from 'lucide-react';

const FEATURES = {
    el: ['Ραντεβού συντήρησης απευθείας από εταιρείες leasing', 'Αποδοχή, πρόταση νέας ημερομηνίας, έναρξη & ολοκλήρωση εργασίας', 'Εβδομαδιαίο ημερολόγιο με χωρητικότητα ανά ημέρα', 'Δικοί σας πελάτες και ραντεβού', 'Chat με τους υπευθύνους στόλου', 'Ωράριο, κλειστές μέρες και αργίες'],
    en: ['Maintenance appointments straight from leasing companies', 'Accept, propose a new date, start & complete jobs', 'Weekly calendar with daily capacity', 'Your own customers and appointments', 'Chat with fleet managers', 'Opening hours, closed days and holidays'],
};

export const WorkshopEditionCard = ({ el, onSignup }) => (
    <div className="max-w-xl mx-auto bg-white rounded-2xl p-8 border-2 border-teal-600 shadow-xl" data-testid="plan-workshop">
        <div className="text-center mb-6">
            <div className="w-12 h-12 mx-auto mb-3 rounded-xl bg-teal-600/10 flex items-center justify-center"><Wrench className="w-6 h-6 text-teal-700" /></div>
            <h3 className="text-xl font-bold text-slate-800 mb-1">{el ? 'Cofleet Συνεργείο' : 'Cofleet Workshop'}</h3>
            <p className="text-sm text-slate-500">{el ? 'Για συνεργεία που συνεργάζονται με εταιρείες leasing' : 'For garages partnering with leasing companies'}</p>
            <p className="mt-4 text-lg font-semibold text-teal-700" data-testid="plan-workshop-price">{el ? 'Η τιμή ανακοινώνεται σύντομα' : 'Pricing announced soon'}</p>
        </div>
        <ul className="grid sm:grid-cols-2 gap-3 mb-6">
            {FEATURES[el ? 'el' : 'en'].map((f) => (
                <li key={f} className="flex items-start gap-2"><Check className="w-5 h-5 text-teal-600 flex-shrink-0 mt-0.5" /><span className="text-sm text-slate-600">{f}</span></li>
            ))}
        </ul>
        <Button onClick={onSignup} className="w-full bg-teal-700 hover:bg-teal-800 text-white" data-testid="plan-workshop-cta">
            {el ? 'Εγγραφή συνεργείου' : 'Sign up your garage'}<ChevronRight className="w-4 h-4 ml-1" />
        </Button>
    </div>
);
